import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { PencilIcon } from '@phosphor-icons/react';
import { Bookmark } from 'lucide-react';
import { Button } from '../../components/ui/button';
import BookmarkDrawerGlobal from '../../components/drawers/BookmarkDrawer';

const BookmarkController = ({ questionId, packId, testId, isNoteButton = false }) => {
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const fetchBookmarkStatus = async () => {
    if (!questionId) return;
    setIsLoading(true);
    try {
      const response = await axios.get(`/api/v1/notebooks/question-status/${questionId}`);
      const notebooks = response.data?.data?.notebooks;
      setIsBookmarked(notebooks && notebooks.length > 0);
    } catch (err) {
      setIsBookmarked(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBookmarkStatus();
  }, [questionId]);

  const handleBookmarkClick = (e) => {
    e.stopPropagation();
    setIsDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
    fetchBookmarkStatus();
  };

  if (isLoading) {
    return <div className="h-5 w-24 rounded-full bg-[var(--q3-surface-default)] animate-pulse" />;
  }

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Button
        variant="ghost"
        className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[var(--q3-neutral-default)] border hover:bg-[var(--q3-neutral-default)]/50} hover:scale-110`}
        onClick={handleBookmarkClick}
      >
        {isNoteButton ? (
          <PencilIcon className="h-4 w-4 text-[var(--q3-accent-normal)]" />
        ) : (
          <Bookmark className="h-4 w-4 text-[var(--q3-accent-normal)]" fill={isBookmarked ? 'currentColor' : 'none'} />
        )}
        <span className="hidden md:block">{isNoteButton ? 'Notes' : isBookmarked ? 'Bookmarked' : 'Bookmark'}</span>
      </Button>

      {isDrawerOpen && (
        <BookmarkDrawerGlobal
          questionId={questionId}
          packId={packId}
          testId={testId}
          handleShowDrawer={handleDrawerClose}
        />
      )}
    </div>
  );
};

export default BookmarkController;
